<script>
export default {
  name: 'LaborerCertificationMixin',
  methods: {
    closeCertificationModal () {
      const createLaborerCertificationRef = this.$refs.createLaborerCertificationRef
      if (createLaborerCertificationRef) {
        createLaborerCertificationRef.disableModal()
      }
    },
    async onCertificationModalSuccess (data, certification, callback) {
      const { laborer } = data
      if (laborer && laborer.vacancyCertification && laborer.vacancyCertification.id) {
        await this.deleteLaborerCertification(laborer.vacancyCertification, callback)
      } else {
        await this.addLaborerCertification(data, certification, callback)
      }
    },
    async addLaborerCertification (data, vacancyCertification, callback) {
      try {
        const model = {
          'vacancy': { 'id': vacancyCertification.id },
          'laborerList': [
            { 'id': data.laborer.id },
          ]
        }
        this.showPageLoader()

        await this.$store.dispatch(
          'organization/certifyLaborer',
          model
        )
        this.closeCertificationModal()
        this.showSuccessNotification('Соискатель успешно добавлен в обучение')
        await callback()
      } catch (error) {
        console.log(error)
        this.showErrorNotification('Ошибка при добавлении обучения')
      } finally {
        this.hidePageLoader()
      }
    },
    async deleteLaborerCertification (data, callback) {
      try {
        const model = { 'id': data.id }
        this.showPageLoader()

        await this.$store.dispatch(
          'organization/deleteLaborerVacancyCertification',
          model
        )
        this.closeCertificationModal()
        this.showSuccessNotification('Соискатель успешно удален в обучение')
        // window.location.reload()
        await callback()
      } catch (error) {
        console.log(error)
        this.showErrorNotification('Ошибка при удалении обучения')
      } finally {
        this.hidePageLoader()
      }
    }
  }
}
</script>
